/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClaimShopDTO = {
    shopId?: string;
    name?: string;
    status?: ClaimShopDTO.status;
    address?: string;
    phoneNumber?: string;
    requestAt?: string;
};
export namespace ClaimShopDTO {
    export enum status {
        ACTIVE = 'ACTIVE',
        WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
        EXPIRED = 'EXPIRED',
        SUSPENDED = 'SUSPENDED',
    }
}

